const { Check } = require('./lib/check');
const { Parameter } = require('./lib/parameter');

module.exports.Check = Check;
module.exports.Parameter = Parameter;
